import React, { useState } from "react";
import { Form, Input, Button, Flex, message, Typography } from "antd";
import { connect } from "react-redux";
import { isLogin, setUserData } from "../Actions/loginAction";
import { setLoading } from "../Actions/loadingAction";
import { useNavigate } from "react-router-dom";
import AxiosService from "../services/APIService";
import { LocalStorageService } from "../services/LocalStorage";
import logo from "../Assets/logo.svg";
import Video from "../Assets/video.webm";
import AuthImage from "../Assets/auth-layer.png";
import VecImage from "../Assets/vec-img.png";
import { PRODUCT } from "../const";

const { Title, Text } = Typography;

function Login({ isLoading, setLoading, isUserLogin }) {
    const apiService = new AxiosService();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [isForgotPassword, setIsForgotPassword] = useState(false);

    React.useEffect(() => {
        const token = LocalStorageService.getItem("userToken");
        if (token || isUserLogin) {
            navigate("/dashboard");
        }
    }, [navigate, isUserLogin]);

    const onFinish = (val) => {
        setLoading(true);
        const requestData = {
            email: val?.email,
            password: val?.password,
        };

        apiService
            .post("/auth/signin", requestData)
            .then((res) => {
                isLogin(true);
                LocalStorageService.setItem("userToken", res.token);
                LocalStorageService.setItem("user", res.user);
                navigate("/dashboard");
                setLoading(false);
            })
            .catch((e) => {
                message.error(e.error || "Something went wrong");
                isLogin(false);
                setLoading(false);
            });
    };

    const handleForgotPassword = () => {
        setIsForgotPassword(true);
    };

    const handleBackToLogin = () => {
        setIsForgotPassword(false);
        setEmail("");
    };

    const handleResetPassword = () => {
        if (!email) {
            return message.error("Please enter your email!");
        }

        setLoading(true);
        apiService
            .post("/auth/forgot-password", { email })
            .then(() => {
                message.success("Reset link sent to your email.");
                setIsForgotPassword(false);
                setEmail("");
                setLoading(false);
            })
            .catch((err) => {
                message.error(err?.error || "Failed to send reset link.");
                setLoading(false);
            });
    };

    const handleSignUp = () => {
        const randomProduct = PRODUCT[Math.floor(Math.random() * PRODUCT.length)];
        navigate(`/registration?productName=${randomProduct.productName}`);
    };

    return (
        <div className="">
            <div className="main-layer">
                <div className="">
                    <div className="main-box">
                        <div className="grid">
                            <div className="grid-items">
                                <div className="layerimg">
                                    <img src={AuthImage} alt="AuthImage" />
                                </div>
                                <div className="vec-img">
                                    <img src={VecImage} alt="VecImage" />
                                </div>
                                <div className="all-content-top-alignment">
                                    <div className="spacing-alignment">
                                        <div className="button-design-layer right-alignment">
                                            <button>Zero Trading Knowledge required</button>
                                        </div>
                                        <div className="button-design-layer ">
                                            <button>Zero Experience required</button>
                                        </div>
                                        <div className="button-design-layer right-alignment">
                                            <button>Zero monitoring required</button>
                                        </div>
                                        <div className="button-design-layer ">
                                            <button>Zero Time Required</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="grid-items">
                                <div className="w-full login-form-width">
                                    <div className="logo-center">
                                        <img src={logo} alt="Logo" style={{ width: 300 }} />
                                    </div>
                                    <div className="login-text">
                                        <h3>
                                            Log In
                                        </h3>
                                        <p>
                                            Unlock Your Dashboard
                                        </p>
                                    </div>
                                    {!isForgotPassword ? (
                                        <Form
                                            name="basic"
                                            onFinish={onFinish}
                                            autoComplete="off"
                                            layout="vertical"
                                            className="login-form "
                                        >
                                            <Form.Item
                                                className="login-form-design"
                                                label="Email Id (User name)"
                                                name="email"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Please Enter Email!",
                                                    },
                                                ]}
                                            >
                                                <Input autoComplete="off" />
                                            </Form.Item>
                                            <Form.Item
                                                label="Password"
                                                name="password"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Please Enter Password!",
                                                    },
                                                ]}
                                            >
                                                <Input.Password autoComplete="new-password" />
                                            </Form.Item>


                                            <div className="forgot-password" onClick={handleForgotPassword} style={{ cursor: "pointer" }}>
                                                <p>
                                                    Forgot Password?
                                                </p>
                                            </div>

                                            <Flex className="button-design" justify="center" >
                                                <Button
                                                    htmlType="submit"
                                                    loading={isLoading}
                                                    disabled={isLoading}
                                                    size="large"
                                                    className="login-btn"
                                                >
                                                    Login to Dashboard
                                                </Button>
                                            </Flex>
                                            <div className="details-text">
                                                <p>
                                                    New Here?   <span>Create Free Account</span>
                                                </p>
                                                <h5>Need Help? Contact Support support@makemyprofits.com</h5>
                                            </div>

                                        </Form>
                                    ) : (
                                        <Form onFinish={handleResetPassword} layout="vertical" className="login-form" autoComplete="off">
                                            <Form.Item label="Email" required className="login-form-design">
                                                <Input
                                                    type="email"
                                                    autoComplete="off"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </Form.Item>

                                            <Flex className="button-design top-alignment" justify="end" >
                                                <Button htmlType="submit" size="large" className="login-btn" loading={isLoading} disabled={isLoading}>
                                                    Send Reset Link
                                                </Button>
                                            </Flex>

                                            <Flex justify="center">
                                                <div
                                                    style={{ cursor: "pointer" }}
                                                    className="back-to-login"
                                                    onClick={handleBackToLogin}
                                                >
                                                    <p>Back to Login</p>
                                                </div>
                                            </Flex>
                                        </Form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="auth-wrapper-col left">
                    <div style={{ width: "20%", padding: 24 }}>
                        <div className="card-wrapper">
                            <Flex style={{ marginBottom: "30px" }} justify="center">
                                <img src={logo} alt="Logo" style={{ width: 300 }} />
                            </Flex>

                            {!isForgotPassword ? (
                                <Form
                                    name="basic"
                                    onFinish={onFinish}
                                    autoComplete="off"
                                    layout="vertical"
                                    className="login-form"
                                >
                                    <Form.Item
                                        label="Email"
                                        name="email"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please Enter Email!",
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        label="Password"
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please Enter Password!",
                                            },
                                        ]}
                                    >
                                        <Input.Password />
                                    </Form.Item>

                                    <Flex justify="end" style={{ marginBottom: 30 }}>
                                        <div onClick={handleForgotPassword} style={{ cursor: "pointer" }}>
                                            <Text underline style={{ color: "white" }}>Forgot Password?</Text>
                                        </div>
                                    </Flex>

                                    <Flex justify="center" style={{ marginBottom: "20px" }}>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            loading={isLoading}
                                            size="large"
                                            className="login-btn"
                                        >
                                            Login
                                        </Button>
                                    </Flex>

                                </Form>
                            ) : (
                                <Form onFinish={handleResetPassword} layout="vertical" className="login-form">
                                    <Form.Item label="Email" required>
                                        <Input
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </Form.Item>

                                    <Flex justify="end" style={{ marginBottom: 20 }}>
                                        <Button type="primary" htmlType="submit" size="large">
                                            Send Reset Link
                                        </Button>
                                    </Flex>

                                    <Flex justify="end">
                                        <Text
                                            onClick={handleBackToLogin}
                                            style={{ color: "#BFFE67", cursor: "pointer", textDecoration: "underline" }}
                                        >
                                            Back to Login
                                        </Text>
                                    </Flex>
                                </Form>
                            )}
                        </div>
                    </div>
                </div> */}
        </div>
    );
}

const mapStateToProps = ({ loading, login }) => {
    const { isLoading } = loading;
    const { isUserLogin } = login;
    return {
        isLoading,
        isUserLogin
    };
};

const mapDispatchToProps = {
    isLogin,
    setUserData,
    setLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
